// LocalStorage key for column widths
const COLUMN_WIDTHS_STORAGE_KEY = 'tableView_columnWidths_v2';

/**
 * Get stored column widths from localStorage
 * @param {string} campaignId - The campaign ID to get column sizing for
 * @returns {Object} The stored column sizing object, or empty object if not found
 */
export const getStoredColumnSizing = (campaignId) => {
  if (!campaignId) return {};
  try {
    const stored = localStorage.getItem(`${COLUMN_WIDTHS_STORAGE_KEY}_${campaignId}`);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

/**
 * Save column widths to localStorage
 * @param {string} campaignId - The campaign ID to save column sizing for
 * @param {Object} sizing - The column sizing object to save
 */
export const saveColumnSizing = (campaignId, sizing) => {
  if (!campaignId) return;
  try {
    localStorage.setItem(`${COLUMN_WIDTHS_STORAGE_KEY}_${campaignId}`, JSON.stringify(sizing));
  } catch (e) {
    console.warn('Failed to save column widths:', e);
  }
};
